// /#/forgot-password
// 用户输邮箱 → 调 /auth/password/forgot → 服务端发"重置密码"邮件 (intent=reset)
// 邮件链接点开后 verify 跳到 /#/reset-password?session= 而不是 auth-success

import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";

import { AuthApiError, requestPasswordReset } from "../lib/auth-api";

type Stage =
  | { kind: "idle" }
  | { kind: "submitting" }
  | { kind: "sent"; email: string }
  | { kind: "error"; message: string };

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [stage, setStage] = useState<Stage>({ kind: "idle" });

  async function submit(e: FormEvent) {
    e.preventDefault();
    const value = email.trim();
    if (!value) return;
    setStage({ kind: "submitting" });
    try {
      await requestPasswordReset(value);
      setStage({ kind: "sent", email: value });
    } catch (err) {
      const message =
        err instanceof AuthApiError
          ? err.serverMessage
          : err instanceof Error
            ? err.message
            : "未知错误";
      setStage({ kind: "error", message });
    }
  }

  const sent = stage.kind === "sent";

  return (
    <section className="page page--login">
      <h1>找回密码</h1>
      <p className="muted">
        输入你的注册邮箱，我们会发一封含"重置密码"链接的邮件。
        点击链接后直接进入设置新密码页面。
      </p>

      <form className="form" onSubmit={submit}>
        <label className="form__row">
          <span>邮箱</span>
          <input
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={stage.kind === "submitting" || sent}
            required
            autoFocus
          />
        </label>

        <div className="form__actions">
          <button
            className="btn btn--primary"
            type="submit"
            disabled={stage.kind === "submitting" || sent || !email.trim()}
          >
            {stage.kind === "submitting"
              ? "发送中…"
              : sent
                ? "已发送"
                : "发送重置邮件"}
          </button>
          <Link to="/" className="btn btn--ghost">
            返回登录
          </Link>
        </div>

        {sent && (
          <div className="login-hint">
            <p>
              📧 已发送重置链接到 <code>{stage.email}</code>。
              10 分钟内点击邮件里的链接，进入设置新密码页面。
            </p>
          </div>
        )}

        {stage.kind === "error" && (
          <div className="login-hint login-hint--error">
            <p>发送失败：{stage.message}</p>
          </div>
        )}
      </form>
    </section>
  );
}
